import { Auth0Verrific } from 'verrific-plus-schema';
import { getMyDoInfo } from '../Screens/Private/Payment/SetupPage.api';

export const getPlanType = async () => {
  if (Auth0Verrific.isCompanyAuthorized()) {
    return '';
  }
  const dentalOfficeId = Auth0Verrific.getOfficeId();
  if (!dentalOfficeId) {
    return '';
  }
  return await getMyDoInfo(dentalOfficeId);
};